import { INVALID_POSTCODE } from './constants';

export class DeliveryDetailsService {
  static transformResponse(
    { result: arrayOfDeliveries, isSuccess, errorMessage }: Response<dto.OrderDeliveryDTO[]>,
  ): dto.OrderDeliveryDTO[] {
    if (!isSuccess && errorMessage === INVALID_POSTCODE) {
      throw new Error(INVALID_POSTCODE);
    }
    if (!isSuccess || !arrayOfDeliveries.length) {
      return [];
    }

    return arrayOfDeliveries.filter(({ OrderItemReference }) => OrderItemReference);
  }
}
